import React, { FC } from "react";
import styled, { css } from "styled-components";
import { products_shop_collections_products } from "../../__generated__/products";

interface Ingredient {
  id: string;
  name: string;
  amount: number;
  price: number;
}
interface Props {
  label: string;
  selectedIngredients: Ingredient[];
  setIngredients: any;
  allIngredients: products_shop_collections_products[];
}

const DetailsFilter: FC<Props> = ({
  label,
  selectedIngredients,
  allIngredients,
  setIngredients,
  ...props
}) => {
  const formattedAllIngredients = allIngredients?.map((item) => ({
    ...item,
    id: item.variants[0].id,
    amount: 0,
  }));

  const combinedIngredients = formattedAllIngredients?.map((ingredient) => {
    const selectedIngredient = selectedIngredients?.find((item) => {
      return item.amount && item.id === ingredient.id;
    });
    return {
      ...ingredient,
      amount: selectedIngredient ? 1 : 0,
    };
  });

  return (
    <Wrapper {...props}>
      <Head>{label}</Head>
      <Div className={combinedIngredients?.length === 1 ? "single" : ""}>
        {combinedIngredients?.map((ingredient) => {
          const {
            name,
            amount,
            variants: [{ id, price, weight }],
          } = ingredient;

          return (
            <Block
              key={id}
              onClick={() => {
                const formattedIngredient: Ingredient = {
                  id,
                  name,
                  amount,
                  price,
                };

                setIngredients((prevIngredients) => {
                  let newIngredients = [...prevIngredients];
                  const selected = prevIngredients?.find((i) => i.id === id);

                  if (selected) {
                    newIngredients = newIngredients?.filter((i) => i.id !== id);
                  } else {
                    newIngredients?.push({ ...formattedIngredient, amount: 1 });
                  }

                  return newIngredients;
                });
              }}
            >
              <Label active={!!amount} />
              <Info>
                <UpperBlock>
                  {price && `${price}₽`}
                  {!!weight && Number(weight) > 0 && ` ${weight}гр.`}
                </UpperBlock>
                <Name className="font-big">{name}</Name>
              </Info>
            </Block>
          );
        })}
      </Div>
    </Wrapper>
  );
};

const Wrapper = styled.div``;

const Div = styled.div`
  column-count: 3;

  &.single {
    column-count: initial;
  }

  @media (max-width: 90rem) {
    column-count: 2;
  }

  @media (max-width: 40rem) {
    column-count: 1;
  }
`;

const Head = styled.p`
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 10px;
`;

const Info = styled.div`
  cursor: pointer;
  margin-left: 10px;
  user-select: none;
`;

const UpperBlock = styled.p`
  font-size: 12px;
  color: #818181;
  margin-bottom: 0;
`;

const Block = styled.div`
  display: flex;
  break-inside: avoid;
  margin-bottom: 30px;
  margin: 0 20px 20px 0;
`;

interface LabelProps {
  active?: boolean;
}

const ActiveLabel = css`
  background-color: #78b833;
  background-image: url("../../static/icons/check-mark.svg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 17px;
`;

const Label = styled.label<LabelProps>`
  min-width: 40px;
  height: 40px;
  background: #e1e1dd;
  background-color: #e1e1dd;
  border-radius: 4px;
  cursor: pointer;

  ${({ active }) => active && ActiveLabel}
`;

interface FilterWithProps {
  active?: boolean;
}

const Name = styled.p<FilterWithProps>`
  border-radius: 15px;
  display: flex;
  align-items: center;
  margin: 0 16px 16px 0;
  line-height: 1.1;
`;

export default DetailsFilter;
